import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import Config from "../../../core/config/Config";
import NavigateEvent from "../../../core/navigation/NavigateEvent";
import SkinFactory from "../../../core/ui/SkinFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";

export default class ConsoleDebugTask extends Task {
    /**
     * @param {soma.EventDispatcher} dispatcher
     * @param {Config} config
     */
    constructor(dispatcher, config) {
        super();
        this._dispatcher = dispatcher;
        this._config = config;
    }

    async execute(callback) {
        const allowConsoleSkipContent = this._config.getValue("settings.allowConsoleSkipContent");
        if (!allowConsoleSkipContent) {
            callback();
            return;
        }

        window.ranj = window.ranj || {};
        window.ranj.skipContent = () => {
            const screenSkin = SkinFactory.getSkin(SkinKeyRegistry.END_OF_GAME_SCREEN_SKIN);

            const evt = new NavigateEvent(NavigateEvent.GOTO_SCREEN_REQUEST, null, screenSkin);
            this._dispatcher.dispatch(evt.type, { data: evt });
        };

        console.warn(`Debug console commands enabled!`);

        callback();
    }
}